export const GLOBAL_TENANT_FETCH_MIN_PAGE_SIZE = 100;
